import { onValue, orderByChild, query, set } from "firebase/database";
import {
    FETCH_DOCUMENT_FIELDS,
    FETCH_DOCUMENT_FIELDS_SUCCESS,
    FETCH_DOCUMENT_FIELDS_FAILED,
    UPDATE_DOCUMENT_FIELDS,
} from "../store/types";
import { firebase } from "../config/configureFirebase";

export const fetchDocumentFields = () => (dispatch) => {
    try {
        const { documentFieldRef } = firebase;

        if (!documentFieldRef) {
            console.error(
                "Firebase documentFieldRef is not properly initialized"
            );
            dispatch({
                type: FETCH_DOCUMENT_FIELDS_FAILED,
                payload: "Firebase reference not initialized",
            });
            return;
        }

        dispatch({
            type: FETCH_DOCUMENT_FIELDS,
            payload: null,
        });

        onValue(
            query(documentFieldRef, orderByChild("created_at")),
            (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const sortedData = Object.entries(data)
                        .sort(
                            ([, a], [, b]) =>
                                (b.created_at || 0) - (a.created_at || 0)
                        )
                        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

                    dispatch({
                        type: FETCH_DOCUMENT_FIELDS_SUCCESS,
                        payload: sortedData,
                    });
                } else {
                    dispatch({
                        type: FETCH_DOCUMENT_FIELDS_FAILED,
                        payload: "Unable to fetch document field settings.",
                    });
                }
            },
            (error) => {
                dispatch({
                    type: FETCH_DOCUMENT_FIELDS_FAILED,
                    payload: error.message,
                });
            }
        );
    } catch (error) {
        console.error("fetchDocumentFields error:", error);
        dispatch({
            type: FETCH_DOCUMENT_FIELDS_FAILED,
            payload: error.message,
        });
    }
};

export const updateDocumentFields =
    (data, onSuccess, onError) => (dispatch) => {
        try {
            console.log("🔍 updateDocumentFields called with data:", data);

            const { documentFieldEditRef } = firebase;

            console.log("🔍 Firebase object:", firebase);
            console.log(
                "🔍 documentFieldEditRef function:",
                documentFieldEditRef
            );

            if (!documentFieldEditRef) {
                console.error(
                    "❌ Firebase documentFieldEditRef is not properly initialized"
                );
                onError();
                return;
            }

            if (!data || !data.id) {
                console.error("❌ Data or data.id is missing:", data);
                onError();
                return;
            }

            dispatch({
                type: UPDATE_DOCUMENT_FIELDS,
                payload: data,
            });

            const firebaseRef = documentFieldEditRef(data.id);
            console.log("🔍 Firebase reference path:", firebaseRef.toString());

            console.log("📤 Saving document field to Firebase:", {
                id: data.id,
                name: data.name,
                internal_name: data.internal_name,
                for_user: data.for_user,
                entry_type: data.entry_type,
                fullData: data,
            });

            set(firebaseRef, data)
                .then(() => {
                    console.log(
                        "✅ Document field saved to Firebase successfully"
                    );
                    onSuccess();
                })
                .catch((error) => {
                    console.error(
                        "❌ Error saving document field to Firebase:",
                        error
                    );
                    console.error("❌ Error details:", {
                        code: error.code,
                        message: error.message,
                        stack: error.stack,
                    });
                    onError();
                });
        } catch (error) {
            console.error("❌ Error in updateDocumentFields:", error);
            console.error("❌ Error details:", {
                message: error.message,
                stack: error.stack,
            });
            onError();
        }
    };
